import React from "react";

function AboutUs() {
  return (
    <div className="about-us-container" id="about us">
      <div className="about-us-right">
        <h1 className="about-us-right-title">
          ABOUT US
          <span style={{ color: "#4cb88f" }}>.</span>
        </h1>
        <p className="about-us-right-content-txt">
          We’re a small team consisting of student developers attending <br />{" "}
          Carleton University in <strong>Ottawa</strong>
        </p>
        <div className="about-us-right-container">
          <div className="about-us-individual-container">
            <div className="ryanPic"></div>
            <div className="profileInformationDiv">
              <h1 className="profileName">Ryan Burry</h1>
              <h2 className="profileTitle-and-Bio">Founder</h2>
              <p className="profileTitle-and-Bio" style={{ marginTop: "15px" }}>
                Ryan is a Computer Systems Engineering student at{" "}
                <strong>
                  <i>Carleton University</i>
                </strong>
                . He started his <br /> web development journey during lockdown
                in March 2020 and has been expanding his <br /> knowledge each
                and every day.
              </p>
            </div>
          </div>
          <div className="about-us-individual-container oddMembersPic">
            <div className="profileInformationDiv oddMembersText">
              <h1 className="profileName">Brady Hoard</h1>
              <h2 className="profileTitle-and-Bio">Founder</h2>
              <p className="profileTitle-and-Bio" style={{ marginTop: "15px" }}>
                Brady is a Computer Science Student in the stream of Computer
                and Internet Security at
                <strong>
                  <i> Carleton University</i>
                </strong>
                . <br />
                He started to take a strong interest in web development during
                his first co-op as an <br /> assistent frontend developer for
                Carleton University in September of 2021.
              </p>
            </div>
            <div className="profilePic"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
//afsdfasdf
